export default "__VITE_ASSET__CqQOW3vj__"